import _ from "lodash";
import CONFIG from "../../../config/config";

const AUTOMATION_BLOCK_TYPES = {
    START_POINT: "START_POINT",
    DEFAULT_FALLBACK: "DEFAULT_FALLBACK",
    DEFAULT_TIMEOUT: "DEFAULT_TIMEOUT",
    FALLBACK: "FALLBACK",
    TIMEOUT: "TIMEOUT",
    FILTER: "FILTER",
    SLEEP: "SLEEP",
    NOOP: "NOOP",
    FLOW: "FLOW",
    GO_TO_STEP: "GO_TO_STEP",
    ADD_TO_SEGMENT: "ADD_TO_SEGMENT",
    REMOVE_FROM_SEGMENT: "REMOVE_FROM_SEGMENT",
    WEBHOOK: "WEBHOOK",
    CATCH_WEBHOOK: "CATCH_WEBHOOK",
    SET_ATTRIBUTE: "SET_ATTRIBUTE",
    TERMINATE_AUTOMATION: "TERMINATE_AUTOMATION",
    CREATE_TICKET: "CREATE_TICKET",
    TRANSFER_CHAT: "TRANSFER_CHAT",
    TRANSFER_TO_CHATBOT: "TRANSFER_TO_CHATBOT",
    SET_DEPARTMENT: "SET_DEPARTMENT",
    SUCCESS: "SUCCESS",
    FAILURE: "FAILURE",
    CREATE_RESERVATION: "CREATE_RESERVATION",
    SEND_SMS: "SEND_SMS",
    SEND_MAIL: "SEND_MAIL",
    CREATE_EVENT: "CREATE_EVENT",
    CREATE_TASK: "CREATE_TASK",
    SUPPRESSION_ADD: "SUPPRESSION_ADD",
    SUPPRESSION_REMOVE: "SUPPRESSION_REMOVE",
    SEND_WP_BUSINESS_MESSAGE: "SEND_WP_BUSINESS_MESSAGE",
    WAIT_FOR: "WAIT_FOR",
    MESSAGE_RECEIVED: "MESSAGE_RECEIVED",
    CREATE_CONTACT: "CREATE_CONTACT",
    UPDATE_CONTACT: "UPDATE_CONTACT",
    FIND_CONTACT_BY_EMAIL: "FIND_CONTACT_BY_EMAIL",
    FIND_CONTACT_BY_NUMBER: "FIND_CONTACT_BY_NUMBER",
    FIND_CONTACTS: "FIND_CONTACTS",
    FIND_CONTACT: "FIND_CONTACT",
    FIND_CHATS: "FIND_CHATS",
    FIND_CHAT: "FIND_CHAT",
    LOOP: "LOOP",
    LOOP_NEXT: "LOOP_NEXT",
    LOOP_FINISH: "LOOP_FINISH",
    LOOP_BREAK: "LOOP_BREAK",
    LOOP_CONTINUE: "LOOP_CONTINUE",
    UPDATE_PROFILE: "UPDATE_PROFILE",
    STRING_FORMAT: "STRING_FORMAT",
    NUMBER_FORMAT: "NUMBER_FORMAT",
    DATE_FORMAT: "DATE_FORMAT",
    RECORDS_FROM_CSV: "RECORDS_FROM_CSV",
};

AUTOMATION_BLOCK_TYPES.ALL_BLOCKS = Object.keys(AUTOMATION_BLOCK_TYPES).map((key) => AUTOMATION_BLOCK_TYPES[key]);

AUTOMATION_BLOCK_TYPES.TERMINATION_BLOCKS = [
    AUTOMATION_BLOCK_TYPES.TERMINATE_AUTOMATION,
    AUTOMATION_BLOCK_TYPES.TRANSFER_CHAT,
    AUTOMATION_BLOCK_TYPES.GO_TO_STEP,
    AUTOMATION_BLOCK_TYPES.TRANSFER_TO_CHATBOT,
];
AUTOMATION_BLOCK_TYPES.MULTI_CHILD_BLOCKS = [
    AUTOMATION_BLOCK_TYPES.WEBHOOK,
    AUTOMATION_BLOCK_TYPES.CREATE_EVENT,
    AUTOMATION_BLOCK_TYPES.CREATE_RESERVATION,
    AUTOMATION_BLOCK_TYPES.SEND_WP_BUSINESS_MESSAGE,
    AUTOMATION_BLOCK_TYPES.WAIT_FOR,
];
AUTOMATION_BLOCK_TYPES.INPUT_BLOCKS = [];
AUTOMATION_BLOCK_TYPES.MAIN_RESTRICT_BLOCKS = [
    AUTOMATION_BLOCK_TYPES.GO_TO_STEP,
    AUTOMATION_BLOCK_TYPES.TERMINATE_AUTOMATION,
    AUTOMATION_BLOCK_TYPES.WEBHOOK,
];
AUTOMATION_BLOCK_TYPES.SPECIAL_BLOCKS = [];

AUTOMATION_BLOCK_TYPES.TAILED_FLOW_BLOCKS = [];

const isElseIfBlockPattern = (block, sourceType) => {
    block = _.cloneDeep(block);
    const validPatterns = [
        [AUTOMATION_BLOCK_TYPES.FALLBACK],
        [AUTOMATION_BLOCK_TYPES.FILTER],
        [AUTOMATION_BLOCK_TYPES.FILTER, AUTOMATION_BLOCK_TYPES.FALLBACK],
        [AUTOMATION_BLOCK_TYPES.ADD_TO_SEGMENT],
        [AUTOMATION_BLOCK_TYPES.REMOVE_FROM_SEGMENT],
        [AUTOMATION_BLOCK_TYPES.TIMEOUT],
        [AUTOMATION_BLOCK_TYPES.FALLBACK, AUTOMATION_BLOCK_TYPES.TIMEOUT],
    ].map((arr) => _.orderBy(arr, (q) => q, ["asc"]));
    const currentPattern = _.chain(
        _.concat(
            block.children.map((child) => child.type),
            [sourceType]
        )
    )
        .uniq()
        .orderBy((q) => q, ["asc"])
        .value();
    const isValid = _.some(validPatterns, (pattern) => _.isEqual(pattern, currentPattern));
    console.log("isElseIfBlockPattern 2", {
        block,
        sourceType,
        validPatterns,
        currentPattern,
        isValid,
    });
    return isValid;
};
AUTOMATION_BLOCK_TYPES.isElseIfBlockPattern = isElseIfBlockPattern;
export default AUTOMATION_BLOCK_TYPES;
